import { ElLoading } from 'element-plus'
import JSEncrypt from 'jsencrypt'
import { reqPubKey } from '@/api/modules/login'
import { initRDKitModule } from '@/utils/rdkitLoader'

/* 上传文件公共参数
*  * @returns {object}
* */
export function uploadParams() {
  return {
    'x-token': '',
  }
}

export async function downloadFile(data: any) {
  const downloadLoadingInstance = ElLoading.service({ text: '正在下载数据，请稍候', background: 'rgba(0, 0, 0, 0.7)' })
  try {
    const url = data.file_detail.file
    const fileName = data.name
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.responseType = 'blob'
    xhr.onload = function () {
      const blob = xhr.response
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.target = '_blank' // 可选，如果希望在新窗口中下载文件，请取消注释此行
      link.click()
    }
    xhr.send()
  }
  catch (error) {
    window.console.log(error, 'downloadFile')
  }
  finally {
    downloadLoadingInstance.close()
  }
}

// 自定义导出
export function exportFile(res: any, name?: string) {
  const contentDisposition = res.headers['content-disposition']
  let fileName: any = ''
  if (contentDisposition && !name) {
    const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
    if (fileNameMatch && fileNameMatch[1]) {
      fileName = fileNameMatch[1].replace(/['"]/g, '')
    }
  }
  else {
    fileName = name
  }
  const blob = new Blob([res.data], {
    type: res.data.type, // 将会被放入到blob中的数组内容的MIME类型
  })
  const objectUrl = URL.createObjectURL(blob) // 生成一个url
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = fileName
  a.click()
}

export function checkMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  // 常见的移动设备关键词
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
  return mobileRegex.test(userAgent)
}

/**
 * RSA加密方法
 * @param {string} text - 需要加密的文本
 * @param {string} publicKey - 公钥
 * @returns {string} 加密后的文本
 */
export async function rsaEncrypt(text: any, username: any) {
  try {
    const publicKey: any = await reqPubKey({ username })
    if (publicKey && publicKey.code === 200) {
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(publicKey.data.pubKey)
      localStorage.setItem('publicKey', publicKey.data.pubKey)
      const params = {
        code: 200,
        uuid: publicKey.data.uuid,
        password: encrypt.encrypt(text),
      }
      return params
    }
  }
  catch (error) {
    console.error('RSA加密失败:', error)
    throw error
  }
}

/**
 * RSA加密方法
 * @param {string} text - 需要加密的文本
 * @returns {string} 加密后的文本
 */
export function rsaEncryptPassword(text: any) {
  try {
    const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwgSNLVdfGJ4NEmsvs0x9ZMHLRt9SO/8gamDIoVWJiVy0cgkFkulO2aWe0DwswcdAbfhH8gvky6VjpSUvZVdmQfzPCZhyAr4tD5xEnQcc8/3EudCmz87RYpqsmGOMfqpYwj7j8rEizGgw8BKka+s1c1CKkfYupfS32F2HiFB7XQLBWBSpzYE18W2j+Ebxoh0U7LhLvUvcK43+6VD8uktpdERD9QVwUTMDMTcer7lqwtiA7p2bjRwkHH9zCCtB5J5Guy0YC2WazjiPxZ56gKMpEGf6rjH3xFxXQzXKE43knSVIqmP1hYV0J7/IEpQEY2a3OnQ0BVt6MVAgljJaw+RrVwIDAQAB'
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(publicKey)
    return encrypt.encrypt(text)
  }
  catch (error) {
    console.error('RSA加密失败:', error)
    throw error
  }
}
/**
 * RSA解密方法
 * @param {string} encryptedText - 需要解密的文本
 * @returns {string} 解密后的文本
 */
export function rsaDecryptPassword(encryptedText: any) {
  try {
    const privateKey = 'MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQDCBI0tV18Yng0Say+zTH1kwctG31I7/yBqYMihVYmJXLRyCQWS6U7ZpZ7QPCzBx0Bt+EfyC+TLpWOlJS9lV2ZB/M8JmHICvi0PnESdBxzz/cS50KbPztFimqyYY4x+qljCPuPysSLMaDDwEqRr6zVzUIqR9i6l9LfYXYeIUHtdAsFYFKnNgTXxbaP4RvGiHRTsuEu9S9wrjf7pUPy6S2l0REP1BXBRMwMxNx6vuWrC2IDunZuNHCQcf3MIK0Hknka7LRgLZZrOOI/FnnqAoykQZ/quMffEXFdDNcoTjeSdJUiqY/WFhXQnv8gSlARjZrc6dDQFW3oxUCCWMlrD5GtXAgMBAAECggEAAJ7To/RlX2r6PzBO3Bn6YzszLqOjdS5g2RmV0/WYGVuv6q6xJR17V+Sev0j0Bcd+iDz7I/Zd79/MIo3oM1iiAQszk4q1hbGJgJVzijTGiRPa0QpGOONEnh47FaSAyA6V1g1dmD1q+n/eAQgzn907oIjykrkUGbDNj+J09eywVSM13e6a4iHwXuBCP5+qwjHyPvUJ39kNgERy8jrsKz3UaEJv6NJF0k/gclSyFwvZmpnx3AOrCo81N7ErDBiRrV7tpMHnAeJIoe9zvpgUs+vLeY3Xxz1y7lvBPOcVgG+qluTxJ6b2/J3JWx9ftcknmo8sAWvI5SSrhqYSsU1zyEytrQKBgQDiGpV15LwsYE0kh/egEmtuHX8O48fw7uI0I5ESfwLsxVBvQ+i1bcYOb5RTZ1i2IFSbXgwZPnrD9mJUvw+Pe5qYcsh2L35IP6MbCpWigfVficYNiQlu/Og3Fc1JXxowsohAU7wuHOGy7hX3ASFDtfavsF/doPXkBBdo1NxV/iJvvQKBgQDbq+Hynway67uf5YLo2MsmH/eUQhqJ7ntZ2CJCaK5Y7BP3kuBfcD56F5TXyPgt05oTGJwYHAPlyhVImoL/AEIeVs+XmEcNUHrGKbaCZhK8IaMRkAIEUepBxsYq5t62oFgyRHhS5J6s1v2ygT5C85iAviqQbskil53x+TVUqT2+owKBgHfI3aW3qHlaC4RvBCEpoQCVX9rjkelypSQ6M4E5CLOnVRWdRIvZvDOpqUsGVVknh6tIB+DX2PI4dZ+wGO5K7XwWU11Ji/16uU56LQwLDZOvyd0h3H2QPvXv9vIIEDf8XXK26dsEMg45VCmnz5evryEkr6UawSorgLtpCdIE8PmBAoGAd/kzCQBjdzqaGWUPDz7ADM1uuTE1L1npUpNheqWTewtMiG1WT6mM5b+VUhj3uoeT4ZQSRHSgiFLLNwD0RHMOqWU+MYxAWfw3YZ0MicFXwBoa5o+hGlzmtQ/r0SiQQGvoX2PX12X3Z2xv2JsPtx81jjLOKl3nShZGdA5oWxmnmEMCgYAy8fvj/2mgoGWNEuhWlu9rKo1Zm7bxFZMBZHI481UfmGNkPXg0WiuZXuw8rV8YEQuNjjXCRaTuMMH3S4U5UhE/FCXNXzi1jZB6nV6y6DtCyGwqwjLpSmbKKL7HerbEQwPv/QaAGJukTpCT636JbGmtfrRJn0Xrha39JxvGeS4iyQ=='
    const decrypt = new JSEncrypt()
    decrypt.setPrivateKey(privateKey)
    return decrypt.decrypt(encryptedText)
  }
  catch (error) {
    console.error('RSA解密失败:', error)
    throw error
  }
}

/* 下载public文件夹的静态资源
* * @param {string} fileName 文件名称
 * @param {string} fileType 文件类型
 * */
export function downLoadLocalFile(fileName: any) {
  const link = document.createElement('a')
  link.download = fileName
  link.href = `/static/file/${fileName}`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export async function getSvgData(data: any) {
  const RDKitModule = await initRDKitModule()
  const subs = JSON.parse(data.subs)
  const prods = JSON.parse(data.prods)
  data.subSvg = []
  data.prodSvg = []
  subs.forEach((subItem: any) => {
    const tempSub = RDKitModule.get_mol(subItem).get_svg()
    data.subSvg.push(tempSub)
  })
  prods.forEach((prodItem: any) => {
    const tempProd = RDKitModule.get_mol(prodItem).get_svg()
    data.prodSvg.push(tempProd)
  })
}
